import { ToastContainer as ReactToastifyToastContainer, ToastContainerProps } from 'react-toastify';
import { useIsMobile } from 'yoso';
import './ToastContainer.scss';

export const ToastContainer = ({
  closeButton = false,
  limit = 1,
  ...props
}: ToastContainerProps) => {
  const isMobile = useIsMobile(undefined, 1200);
  return (
    <ReactToastifyToastContainer
      closeButton={closeButton}
      position={isMobile ? 'bottom-center' : 'top-right'}
      limit={limit}
      autoClose={3000}
      {...props}
    />
  );
};
